module.exports = __webpack_public_path__ + "static/media/tutorial-goal-pin.4ca4343a.svg";